<template>
  <label class="switch" :class="sizeClass" :for="id">
    <input type="checkbox" :id="id" :value="inputValue" v-model="model" />
    <div class="slider round" :style="sliderSize" />
  </label>
</template>

<script>
export default {
  name: 'BaseCheckBox',
  props: {
    id: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    inputValue: {
      type: Number,
    },
    value: [Boolean, Array],
  },
  computed: {
    sizeClass() {
      if (this.size === 'md') {
        return 'w-50 h-30';
      }
      return '';
    },
    sliderSize() {
      if (this.size === 'md') {
        return {
          '--slider-size': '26px',
          '--slider-transform': 'translateX(74%)',
          '--slider-bottom': '0px',
          '--slider-left': '2px',
        };
      }
      return '';
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="css" scoped>
.switch {
  position: relative;
  display: inline-block;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 50ms;
  transition: 50ms;
}

.slider:before {
  position: absolute;
  content: "";
  height: var(--slider-size);
  width: var(--slider-size);
  left: var(--slider-left);
  bottom: var(--slider-bottom);
  background-color: white;
  -webkit-transition: 50ms;
  transition: 50ms;
}

input:checked + .slider {
  @apply bg-primaryColor;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: var(--slider-transform);
  -ms-transform: var(--slider-transform);
  transform: var(--slider-transform);
  background-color: white;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
